import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function PainSection() {
  const painPoints = ['Agobio diario que no te deja pensar con claridad.', 'Emociones que se acumulan y explotás sin querer.', 'Probaste diarios largos o técnicas complejas, pero no lograste sostenerlas.'];
  return <section className="py-20 px-4 bg-[#FDF8F3]" data-id="element-72">
      <div className="container max-w-4xl mx-auto" data-id="element-73">
        <FadeIn data-id="element-74">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-[#3D3229] mb-16 max-w-2xl mx-auto" data-id="element-75">
            ¿Sentís que tu cabeza no para y te cuesta ordenar tus emociones?
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-76">
          {painPoints.map((point, index) => <FadeIn key={index} delay={index * 0.2} className="h-full" data-id="element-77">
              <div className="bg-white p-8 rounded-2xl shadow-sm h-full border border-[#3D3229]/5 hover:border-[#C4703F]/20 transition-colors duration-300" data-id="element-78">
                <div className="w-12 h-12 bg-red-50 rounded-full flex items-center justify-center mb-6 text-red-400" data-id="element-79">
                  <XCircle className="w-6 h-6" data-id="element-80" />
                </div>
                <p className="text-lg text-[#3D3229]/80 leading-relaxed" data-id="element-81">
                  {point}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}